import React, { useEffect, useState } from "react"
import * as medicalApi from '../../service/medicalApi'
import styles from './ListDataPatient.module.css'
import Button from '../material/button/Button'
import { useNavigate } from "react-router-dom"


import DialogTailwindConfirm from "../DialogTailwindConfirm";
import TableSearchV1 from "../tableV1/tableSearchV1";
import { FaTrashAlt, FaEdit, FaEye } from "react-icons/fa"; 
const customStyles = {
    rows: {
        style: {
            // override the row height
            '&:nth-child(even)': {
                background: '#effff4'
            },
            '&:not(:last-of-type)': {
                borderBottomWidth: 'none'
            },
        }
    },
    headCells: {
        style: {
            // override the cell padding for head cells
            display: 'flex',
            justifyContent: 'center',
            background: '#B8DFC7',
            fontSize: 18,
            '@media (max-width: 800px)': {
                fontSize: 14,
            }
        }
    },
    cells: {
        style: {
            // override the cell padding for data cells
            display: 'flex',
            justifyContent: 'center',
            borber: '1px solid #B8DFC7',
        }
    }
};

export default function ListDataPatient() {

    const navigate = useNavigate()
    const [permissionList, setPermissionList] = useState([])
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [total, setTotal] = useState(null);
    const [filters, setFilters] = useState({});
    const [selectedData, setSelectedData] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    useEffect(() => {
        getActivePermission()
    }, [])

    const getActivePermission = async () => { 
        let res = await medicalApi.getActivePermission() 
        if (res) {
            if (res['data']['code'] === 200) {
                setPermissionList(res['data']['permission_list']);

                setMaxPage(Math.ceil(res["data"]["amount"] / 10));

                setTotal(res["data"]["amount"]);
            } else {
                // console.log(res['data']['message_th'])
            }
        } else {
            // console.log(res['data']['message_th'])
        }
    }

    const remainingTime = (timeStamp) => {
        const dateNow = new Date()
        const date = new Date(timeStamp)
        const diffTime = Math.abs(date - dateNow)

        const hours = Math.floor(diffTime / (1000 * 60 * 60))
        const minutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60))

        return (hours + " ชั่วโมง " + minutes + " นาที")
    }

    const clickResultLab = (item) => {
        navigate("/doctor/permission-lab-patient", {
          state: {
            credential_token: item.credential_token,
          },
        });
    }

    // console.log(permissionList)

    const columns = [
      {
        Header: "No.",
        accessor: "id",
        Filter: "#",
      },
      {
        Header: "ชื่อ",
        accessor: "patient.fname",
        Filter: "text",
        wrap: true,
      },
      {
        Header: "นามสกุล",
        accessor: "patient.lname",
        Filter: "text",
        wrap: true,
      },
      {
        Header: "วันเวลาที่ขออนุญาต",
        accessor: "accept_date.date",
        Filter: "date",
        Cell: ({ row }) => {
          return ( 
            <div>
                {row.original.accept_date.date} {row.original.create_date.time}
            </div>
          );
        },
        minWidth: "200px",
        wrap: true,
      },
      {
        Header: "เวลาที่เหลือ",
        accessor: "credential_token_expire",
        Cell: ({ row }) => {
            return (
                <div>
                    {row.original.status === "ACCEPT" && row.original.access_data_every_time == true ? (
                        <div td> ไม่จำกัดเวลา </div>
                    ) : (
                        <div>{remainingTime(row.original.credential_token_expire)}</div>
                    )}
                </div>
            );
        },
        minWidth: "180px",
        wrap: true,
      },
      {
        Header: "#",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
          <div>
            <Button
              style={{
                background: "#FF9768",
                border: "none",
                color: "#FFFFFF",
              }}
              onClick={() => {
                clickResultLab(row.original);
              }}
            >
              ดูผลแลป
            </Button>
          </div>
          );
        },
      },
    ];

    return (
      <div>
        <TableSearchV1
          columns={columns}
          data={permissionList}
          filters={filters}
          setFilters={setFilters} 
          total={total}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
 
      </div>
    );
}